import { ColumnDef } from "@tanstack/react-table";
import { displayCountOrDash } from "@/core/utils/number";

interface WithSpiffCounts {
  referral_creation_count: number;
}

const NewReferralCol = <T extends WithSpiffCounts>(): ColumnDef<T> => ({
  header: "New referral",
  accessorFn: (row) => row.referral_creation_count,
  cell: ({ getValue }) => displayCountOrDash(getValue() as number),
});

export default NewReferralCol;
